<script setup lang="ts">
  import { TravelDateWidget } from '@/widgets'
</script>

<template>
  <TravelDateWidget />
</template>
